<template>
  <el-container class="padding_leftRight">
    <!-- Table -->
    <el-button type="primary" v-if="hasArrovalHis" @click="dialogTableVisible = true" class="glz_button_right">{{
        VApprovalHistroyButton
    }}</el-button>

    <el-dialog append-to-body :title="title" v-if="dialogTableVisible" :visible.sync="dialogTableVisible" width="60%">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <h1>核验流程</h1>
        </div>
        <!-- 流程图 -->
        <div>
          <lct :sid="sid" :bussinesscode="bussinesscode"></lct>
        </div>
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <h1>核验意见</h1>
        </div>
        <el-table :data="flatData(tableData)" style="width: 100%">
          <el-table-column align="center" type="index" label="序号"></el-table-column>
          <el-table-column property="stepName" :formatter="formatterStepName" label="操作步骤"></el-table-column>
          <el-table-column property="assigner" align="center" label="操作人员" show-overflow-tooltip></el-table-column>
          <el-table-column property="approveStatus" label="核验状态" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.approveStatus.desc }}</span>
            </template>
          </el-table-column>
          <el-table-column property="approveResult" label="核验意见" empty-text="--">
          </el-table-column>
          <el-table-column property="approveTime" label="操作时间" width="260" align="center">
          </el-table-column>
          <!--lbz         -->
          <el-table-column align="center" label="附件" width="90">
            <template slot-scope="scope">
              <el-button @click.native.prevent="batchDownload(scope.$index, tableData)" type="text" size="medium">
                {{ getAttachTitle(scope) }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </el-dialog>
    <!--下载确认弹窗-->
    <show-tip :showTip="downloadDialogTableVisible" :content="content" @showTipFn="showTipFnDo"></show-tip>
  </el-container>
</template>
<script>
import lct from "@/components/lct";
// import lct from '@/view/ademo/lct';
export default {
  name: "approvalHistory",
  props: {
    //用于封装组件的参数传递
    title: {
      type: String,
      default: "核验记录",
    },
    sid: {
      // 业务主体对象ID
      type: String,
      required: true,
    },
    bussinesscode: {
      type: String,
      required: true,
    },
    projectid: {
      type: String,
      default: "",
    },
    VApprovalHistroyButton: {
      type: String,
      default: "核验记录",
    },
    isShowButton: {
      type: Boolean,
      default: true,
    },
    watchFlag: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      initNodeFlag: false,
      tableData: [],
      approvalFlows: [],
      dialogTableVisible: false,
      recordObjectId: this.sid,
      hasArrovalHis: false,
      downloadDialogTableVisible: false,
      recordHistoryId: '',
      content: '',
    };
  },
  components: {
    lct,
  },
  methods: {
    getOApprovalHistoryList: function () {
      // 获取核验历史信息
      let params = new URLSearchParams();
      // params.append("recordObjectId",this.recordObjectId);
      // params.append("bussinessCode",this.bussinesscode);
      // params.append("projectId",this.projectid);
      params.append("recordObjectId", this.recordObjectId);
      params.append("bussinessCode", this.bussinesscode);
      this.$ajax
        .get(process.env.API_HOST + "approval-record-history/list", {
          params: params,
        })
        .then((res) => {
          if (res && res.data.success) {


            let data = res.data.data
            this.$ajax.get('/govp/verificationAttach/listApproveRecordAttach', { params: params }).then((resList) => {
              resList.data = resList.data.data;

              for (let i = 0; i < resList.data.length; i++) {
                for (let j = 0; j < data.listPage.result.length; j++) {
                  if (data.listPage.result[j].data.existsAttach === undefined) {
                    data.listPage.result[j].data.existsAttach = false
                  }
                  if (data.listPage.result[j].data.recordHistoryId == resList.data[i].approveRecordId) {
                    data.listPage.result[j].data.existsAttach = true
                    break
                  }
                }
              }

              let resultData = res.data.data;
              this.tableData = resultData.listPage.result;
              this.approvalFlows = resultData.approvalRelationships;
              this.initNodeFlag = true;
            })






          } else {
            //  this.$message({
            //   message: '数据加载失败',
            //   type:"warning"
            //});
          }
        });
    },
    setShowHisButton() {
      let params = new URLSearchParams();
      params.append("recordObjectId", this.recordObjectId);
      this.$ajax
        .get(process.env.API_HOST + "approval-record-history/hasHis", {
          params: params,
        })
        .then((res) => {
          if (res && res.status == 200) {
            let resultData = res.data;
            if (resultData.data) {
              this.hasArrovalHis = true;
            } else {
              this.hasArrovalHis = false;
            }
          }
        });
    },
    formatterStepName(row, column, value) {
      if (value == "审核") {
        return "核验";
      } else {
        return value;
      }
    },
    getIconClass(stage) {
      //获取驱动的样式
      if (stage == 0) {
        return "el-icon-share";
      } else if (stage == -1) {
        return "el-icon-circle-close";
      } else {
        return "el-icon-circle-check";
      }
    },
    flatData(arr = []) {
      return arr.map((item) => {
        const { data, pageOpers } = item;
        return (
          (data
            ? {
              ...data,
              pageOpers,
            }
            : item) || {}
        );
      });
    },
    batchDownload: function (index, data) {
      //大小个数不需要
      /*console.log('datadata',data)
      let recordHistoryId = data[index].recordHistoryId;
      let params = new URLSearchParams();
      params.append("approveRecordId", recordHistoryId);
      this.$http('verification/approval/index:getBatchDownloadInfo', {params: params}).then((resList) => {
        console.log(resList)
        this.content='确定下载吗'
        this.downloadDialogTableVisible=true
      })*/
      if (data[index].data.existsAttach !== undefined && data[index].data.existsAttach) {
        this.content = '     确定下载吗？    '
        this.downloadDialogTableVisible = true
        this.recordHistoryId = data[index].data.recordHistoryId;
      }


    },
    getAttachTitle: function (scope) {
      if (scope.row.existsAttach !== undefined && scope.row.existsAttach) {
        return '查看附件'
      } else {
        return '无'
      }
    },
    showTipFnDo(val) {
      if (val) {

        let recordHistoryId = this.recordHistoryId;
        //let params = new URLSearchParams();
        let params = {};

        params.approveRecordId = recordHistoryId;
        params.contentType = 1;
        this.$ajax.post('/govp/verificationAttach/batchDownload', params).then((resList) => {
          if (resList.data.success) {
            this.downloadDialogTableVisible = false
            let url = process.env.API_HOST + "/project-filed/downLoadZip?fileName=" + resList.data.data;
            window.open(url);
          }

        })
      } else {
        this.downloadDialogTableVisible = false;
      }
    }
  },
  filters: {
    approvalStatusEnumFormat: function (value) {
      console.log(value);
      let passObject = {
        PASSED: "通过",
        NOPASSED: "不通过",
      };
      return passObject[value];
    },
  },
  watch: {
    // 如果 `sid` 发生改变，这个函数就会运行
    sid: function () {
      this.recordObjectId = this.sid;
      this.getOApprovalHistoryList();
    },
    projectid: function () {
      this.projectid = this.projectid;
      this.getOApprovalHistoryList();
    },
    watchFlag: function () {
      this.getOApprovalHistoryList();
    },
    dialogTableVisible: function () {
      this.getOApprovalHistoryList();
    },
  },
  mounted() {
    if (this.isShowButton) this.setShowHisButton();
    else this.hasArrovalHis = true;
    this.getOApprovalHistoryList();
  },
};
</script>
<style lang="scss" scoped>
/deep/ .cell{
    display: block;
    /* width: 125px; */
    height: auto !important;
    width: 100% !important;
    color: #555;
    font-size: 14px;
    word-break: break-all;
  }
// ::v-deep .el-table__row {
//  /deep/ .cell{
//     display: block;
//     /* width: 125px; */
//     height: auto !important;
//     width: 100% !important;
//     color: #555;
//     font-size: 14px;
//     word-break: break-all;
//   }
   
// }
</style>



// WEBPACK FOOTER //
// src/components/approvalHistory.vue